import { camelToKebab } from '@lighthouse/tools'
import styled, { css } from 'styled-components'

import { TEXT_FONT_NORMAL } from '../../../constants'
import type { FieldStyles, GetFieldInteractionStylesReturn } from '../../../hooks'

export const FieldContentContainer = styled.div`
    min-width: calc(100% - 120px);
    flex: 1;
    width: 100%;
    height: auto;
    align-items: center;
    border-radius: 6px;
`

export const FieldPreviewerContainer = styled.div<{
    isInput?: boolean
    fieldStyles?: FieldStyles
    fieldInteractionStyle?: GetFieldInteractionStylesReturn
    fontFamily?: string
}>`
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: 38px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 6px;
    outline: none;
    background: transparent;

    ${({ fontFamily }) =>
        fontFamily &&
        fontFamily !== TEXT_FONT_NORMAL &&
        css`
            font-family: ${fontFamily};
        `}
    // 修复 user-select: none在低版本safari中会锁定输入框
    @media (any-hover: hover) {
        cursor: pointer;
    }
    &.readonly {
        cursor: not-allowed;
        .ProseMirror {
            cursor: not-allowed;
        }
    }

    & input:not([type='radio']):not([type='checkbox']) {
        background-color: unset;
    }

    // input
    ${({ fieldStyles }) =>
        fieldStyles?.input &&
        css`
            & [data-field-input] {
                ${Object.entries(fieldStyles.input)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

    ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.input?.hoverStyle &&
        css`
            & [data-field-input][data-field-active='false'][data-field-disabled='false']:hover {
                ${Object.entries(fieldInteractionStyle.input.hoverStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.input?.disabledStyle &&
        css`
            & [data-field-input][data-field-disabled='true'] {
                ${Object.entries(fieldInteractionStyle.input.disabledStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

                ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.input?.activeStyle &&
        css`
            & [data-field-input][data-field-active='true'] {
                ${Object.entries(fieldInteractionStyle.input.activeStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}
        // icon
        ${({ fieldStyles }) =>
        fieldStyles?.icon &&
        css`
            & [data-field-input] [data-field-icon] {
                ${Object.entries(fieldStyles.icon)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.icon?.hoverStyle &&
        css`
            & [data-field-active='false'][data-field-disabled='false'] [data-field-icon]:hover {
                ${Object.entries(fieldInteractionStyle.icon.hoverStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.icon?.disabledStyle &&
        css`
            & [data-field-disabled='true'] [data-field-icon] {
                ${Object.entries(fieldInteractionStyle.icon.disabledStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

           ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.icon?.activeStyle &&
        css`
            & [data-field-active='true'] [data-field-icon] {
                ${Object.entries(fieldInteractionStyle.icon.activeStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


         // extra
         ${({ fieldStyles }) =>
        fieldStyles?.extra &&
        css`
            & [data-field-extra] {
                ${Object.entries(fieldStyles.extra)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.extra?.hoverStyle &&
        css`
            & [data-field-extra][data-field-disabled='false']:hover {
                ${Object.entries(fieldInteractionStyle.extra.hoverStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.extra?.disabledStyle &&
        css`
            & [data-field-extra][data-field-disabled='true'] {
                ${Object.entries(fieldInteractionStyle.extra.disabledStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

           ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.extra?.activeStyle &&
        css`
            & [data-field-extra][data-field-active='true'] {
                ${Object.entries(fieldInteractionStyle.extra.activeStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}




        // 其他
        ${({ fieldStyles }) =>
        fieldStyles?.other &&
        css`
            & [data-field-other] {
                ${Object.entries(fieldStyles.other)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}

        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.other?.hoverStyle &&
        css`
            & [data-field-other][data-field-disabled='false']:hover {
                ${Object.entries(fieldInteractionStyle.other.hoverStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}



        ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.other?.disabledStyle &&
        css`
            & [data-field-other][data-field-disabled='true'] {
                ${Object.entries(fieldInteractionStyle.other.disabledStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


        /* 其他-icon */
        ${({ fieldStyles }) =>
        fieldStyles?.otherIcon &&
        css`
            & [data-field-other] [data-field-other-icon] {
                ${Object.entries(fieldStyles.otherIcon)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


           ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.otherIcon?.hoverStyle &&
        css`
            & [data-field-active='false'][data-field-disabled='false'] [data-field-other-icon]:hover {
                ${Object.entries(fieldInteractionStyle.otherIcon.hoverStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `}


           ${({ fieldInteractionStyle }) =>
        fieldInteractionStyle?.otherIcon?.disabledStyle &&
        css`
            & [data-field-disabled='true'] [data-field-other-icon] {
                ${Object.entries(fieldInteractionStyle.otherIcon.disabledStyle)
                    .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
                    .join('\n')}
            }
        `} /* &.error {
            box-shadow: 0 0 0 2px var(--color-red-500);
        } */
    /* 作用于输入框类型 的field */
 /* 作用于非输入框输入的field */
        /* &.error {
            [data-field-border] {
                box-shadow: 0 0 0 2px var(--color-red-500);
            }
        } */
`

// ${({ hoverStyle }) =>
//     hoverStyle &&
//     css`
//         &:hover {
//             ${Object.entries(hoverStyle)
//                 .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
//                 .join('\n')}
//         }
//     `}
// ${({ activeStyle }) =>
//     activeStyle &&
//     css`
//         &:active {
//             ${Object.entries(activeStyle)
//                 .map(([key, value]) => `${camelToKebab(key)}: ${value};`)
//                 .join('\n')}
//         }
//     `}
